<div class="content-wrapper">
  <!-- Content Header (Page header) -->
  <section class="content-header">
    <h1>
      {{title}}
      <small>Control panel</small>
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="">
          <i class="fa fa-dashboard"></i> Home
        </a>
      </li>
      <li class="active">{{title}}</li>
    </ol>
  </section>
  <!-- Main content -->
  <section class="content">
    <div class="row">
      <div class="col-xs-12">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">{{title}} Table</h3>
            <!-- <button class="btn btn-success" (click)="initModal('create')">Create</button> -->
          </div>
          <!-- /.box-header -->
          <div class="box-body table-responsive no-padding">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>BOARD ID</th>
                  <th>DEVICE ID</th>
                  <th>Status</th>
                  <th class="w-1">CREATE AT</th>
                  <!-- <th class="w-1">ACT.</th> -->
                </tr>
              </thead>
              <tbody *ngIf="!isLoading">
                <tr *ngFor="let history of historyList">
                  <td>
                    <code>{{ history.boardId }}</code>
                  </td>
                  <td>
                    <span>{{ history.deviceId }}</span>
                  </td>
                  <td>
                    <span>{{ history.statusType }}</span>
                  </td>
                  <td>
                    <i class="fa fa-clock-o"></i>
                    {{ history.createdAt | date:'hh:mm dd-MM-yyyy' }}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="historyList?.length === 0">
                  <td class="text-center" colspan="8">
                    <span>Can not found.</span>
                  </td>
                </tr>
                <tr *ngIf="historyList?.length !== 0">
                  <td colspan="8">
                    Displaying {{filterParams.page * filterParams.size + 1}} - {{ (filterParams.page) * filterParams.size + historyList?.length
                    }} of {{ totalElements }}
                    <ul *ngIf="filterParams.size < totalElements" class="pagination pull-right">
                      <li [class.disabled]="filterParams.page == 0" (click)="filterParams.page = filterParams.page - 1">
                        <a>
                          <span aria-hidden="true">«</span>
                          Previous</a>
                      </li>
                      <li [class.hidden]="filterParams.page < 3" (click)="filterParams.page = 0">
                        <a>1</a>
                      </li>
                      <li [class.hidden]="filterParams.page < 4" class="disabled hidden">
                        <a>...</a>
                      </li>
                      <li *ngFor="let number of initPaginate()" [class]="filterParams.page == number ? 'active' : class" [class.hidden]="(filterParams.page + 2 < number || filterParams.page - 2 > number)"
                        (click)="filterParams.page = number">
                        <a>{{ number + 1 }}</a>
                      </li>
                      <li [class.hidden]="filterParams.page > totalPage - 5" class="disabled">
                        <a>...</a>
                      </li>
                      <li [class.hidden]="filterParams.page >  totalPage - 4" (click)="filterParams.page = totalPage -1">
                        <a>{{ totalPage }}</a>
                      </li>
                      <li [class.disabled]="filterParams.page == totalPage - 1" (click)="filterParams.page = filterParams.page + 1">
                        <a>
                          <span aria-hidden="true">»</span>
                          Next</a>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tfoot>
            </table>


            <p class="text-center" *ngIf="isLoading">
              <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
              <span class="sr-only">Loading...</span>
            </p>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
    </div>

  </section>
</div>


// WEBPACK FOOTER //
// /build/client-cms/src/app/history/history.component.html